import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberAbbreviation',
  standalone: true,
})
export class NumberAbbreviationPipe implements PipeTransform {
  transform(value: number | string, decimals: number = 0): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;

    if (isNaN(num)) {
      return String(value);
    }

    if (num === 0) {
      return '0';
    }

    const absNum = Math.abs(num);
    const sign = num < 0 ? '-' : '';

    if (absNum >= 1_000_000_000_000) {
      return sign + (absNum / 1_000_000_000_000).toFixed(decimals) + 'T';
    } else if (absNum >= 1_000_000_000) {
      return sign + (absNum / 1_000_000_000).toFixed(decimals) + 'B';
    } else if (absNum >= 1_000_000) {
      return sign + (absNum / 1_000_000).toFixed(decimals) + 'M';
    } else if (absNum >= 1_000) {
      return sign + (absNum / 1_000).toFixed(decimals) + 'K';
    }

    return sign + absNum.toString();
  }
}

